<template>
  <!-- 例子 -->
  <div class="example-item">
    <div id="item-container">
      <!-- 左侧代码及按钮 -->
      <div class="left-container"
           :style="{width: leftContainerSize + '%'}"
           id="code-pane">
        <!-- 按钮 -->
        <div class="button-container">
          <div>
            <el-button @click="frun()">运行</el-button>
            <el-button @click="frefresh()">刷新</el-button>
          </div>

        </div>
        <!-- 代码 -->
        <el-container>
          <el-main>
            <code-editor ref="_firstRefs"
                         id="editor-left-container"
                         class="editor h-100"
                         :isReadOnly="isReadOnly"
                         :value="editorContent"
                         :language="lang"></code-editor>
            <!-- theme="dracula" -->
          </el-main>
        </el-container>
      </div>
      <!-- 拖拽栏 -->
      <div class="handler"
           id="h-handler"
           @mousedown="onSplitterDragStart"
           :style="{left: leftContainerSize + '%'}"></div>
      <!-- 右侧实现 -->
      <div class="right-container"
           :style="{
        width: (100 - leftContainerSize) + '%',
        left: leftContainerSize + '%'
    }">
        <div class="example-pane">
          <iframe id="example-page"
                  src="/data/ol-data.html"></iframe>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
// @ is an alias to /src
import codeEditor from "../components/codeEditor.vue";
import { get } from "@/utils/http";
export default {
  data() {
    return {
      editorContent: "",
      lang: "",
      leftContainerSize: 40,
      isReadOnly: false,
    };
  },
  components: {
    codeEditor,
  },
  methods: {
    onSplitterDragStart() {
      this.mousedown = true;
    },
    parseSourceCode(code) {
      return code.replace(/\/\*[\w\W]*?\*\//, "").trim();
    },
    frefresh() {
      console.log("aaa");
      this.editorContent = "";
      setTimeout(() => {
        get(" /data/ol-data.html")
          // get(" /data/area-pieces.js")
          .then((data) => {
            this.lang = "html";
            this.editorContent = this.parseSourceCode(data);
          })
          .catch((err) => {
            console.log(err);
          });
      }, 20);
      setTimeout(() => {
        this.frun();
      }, 500);
    },
    frun() {
      var code = this.$refs._firstRefs.content;
      var iFrame = document.getElementById("example-page");
      if (!iFrame) {
        return;
      }
      var doc = iFrame.contentWindow || iFrame.contentDocument;
      if (doc.document) {
        doc = doc.document;
      }
      if (!doc) {
        return;
      }
      doc.open();
      doc.write(code);
      doc.close();
    },
  },
  mounted() {
    console.log(this.$route.query);
    this.frefresh();
    window.addEventListener("mousemove", (e) => {
      if (this.mousedown) {
        let percentage = e.clientX / window.innerWidth;
        percentage = Math.min(0.9, Math.max(0.1, percentage));
        this.leftContainerSize = percentage * 100;
      }
    });

    window.addEventListener("mouseup", (e) => {
      this.mousedown = false;
    });
  },
};
</script>
<style lang="scss" scoped>
$handler-width: 5px;
html,
body,
.example-item {
  position: sticky;
  z-index: 1;
  padding: 0;
  margin: 0;
  width: 100%;
  height: calc(100vh - 60px);
}

::v-deep #item-container {
  .handler {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: $handler-width;
    cursor: col-resize;
    z-index: 100;
    background-color: #ccc;
    border-left: 1px solid #ececec;
    // border-right: 1px solid $clr-border;
  }
  #code-pane {
    background-color: #eff0f6;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
  }
}
.button-container {
  height: 40px;
  margin: 0 auto;
  padding: 0 15px;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: white;
  border-radius: 0 0 8px 8px;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
  .el-button {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
}
.el-container {
  width: 100%;
  // height: 100%;
  height: calc(100vh - 100px);
}
.el-main {
  padding: 0;
  position: relative;

  ::-webkit-scrollbar {
    height: 8px;
    width: 8px;
    transition: all 0.3s ease-in-out;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-button {
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    width: 8px;
    min-height: 15px;
    background: rgba(50, 50, 50, 0.6) !important;
    transition: all 0.3s ease-in-out;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5) !important;
  }
}
.right-container {
  position: absolute;
  right: 0;
  width: 50%;
  height: 100%;
  padding: 0;
  // padding-left: $handler-width;
  border: none;
  z-index: 30;
  background: #f3f4fa;
  // background: $clr-bg;
}
.example-pane {
  position: absolute;
  top: 22px;
  right: 15px;
  bottom: 15px;
  left: 20px;
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
  #example-page {
    height: 100%;
    width: 100%;
    border: 0px;
  }
}
</style>